"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['itemDetail'],
  data: function data() {
    return {
      dataList: [],
      bannerList: [],
      actNum: 0
    };
  },
  computed: {
    bgStyle: function bgStyle() {
      var str = '#fff';
      if (this.bannerList.length > 0) {
        if (this.bannerList[this.actNum].backgroundColorType === 0) {
          str = "linear-gradient( 180deg, ".concat(this.bannerList[this.actNum].startColor, " 0%, ").concat(this.bannerList[this.actNum].endColor, " 100%)");
        } else {
          str = "".concat(this.bannerList[this.actNum].backgroundColor);
        }
      }
      return str;
    }
  },
  mounted: function mounted() {
    var _this = this;
    (0, _customPage.moduleDetail)({
      moduleId: this.$props.itemDetail.moduleId
    }).then(function (res) {
      console.log(res);
      _this.dataList = res.data.banner;
      _this.bannerList = res.data.carouselBanner;
    });
  },
  methods: {
    changePic: function changePic(val) {
      this.actNum = val;
    }
  }
};